export const getClipboardReadErrorMessage = () => {
    if (typeof window !== 'undefined' && !window.isSecureContext) {
        return 'Вставка по кнопке недоступна в текущем окружении. Используйте HTTPS, localhost или Ctrl/Cmd+V.';
    }

    return 'Не удалось прочитать системный буфер обмена.';
};
